import { Component, OnInit, Input } from '@angular/core';
import { AuctionStats } from 'src/app/shared/model/vehicle';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-auction-stats',
  templateUrl: './auction-stats.component.html',
  styleUrls: ['./auction-stats.component.scss']
})
export class AuctionStatsComponent implements OnInit {
  @Input() stats: AuctionStats;

  constructor() { }

  ngOnInit() {
    if (!this.stats) {
      this.stats = new AuctionStats();
    }
  }

  get impressionsLabel(): string {
    return this.stats.uniqueImpressions === 1 ? 'impressão' : 'impressões';
  }
  get viewsLabel(): string {
    return this.stats.uniqueViews === 1 ? 'visualização' : 'visualizações';
  }
  get favoritesLabel(): string {
    return this.stats.favorites === 1 ? 'seguidor' : 'seguidores';
  }
  get favoritePersonsLabel(): string {
    return this.stats.favorites === 1 ? 'pessoa que segue' : 'pessoas que seguem';
  }
  get bidsLabel(): string {
    return this.stats.bids === 1 ? 'oferta' : 'ofertas';
  }

}
